export const seo = {
  seo: {
    title: 'Wehrfritz » Ausstatter für Krippe, Kindergarten & Hort',
    description:
      'Seit über 80 Jahren führend im Kindergartenbedarf ✓ Wehrfritz für Innovative Raumkonzepte & 3D-Planung ✓ Kostenfreie Beratung vor Ort » Jetzt entdecken!',
    productTitle: '{{dynamic}} online kaufen » Wehrfritz',
    productDescription:
      '{{dynamic}} ► Ihr Komplettausstatter für Krippe, Kindergarten & Schule ✓ Fördern - bilden - erleben ✓ Jetzt bestellen!',
    categoryTitle: 'online kaufen » Wehrfritz',
    categoryDescription:
      'Ihr Komplettausstatter für Krippe, Kindergarten & Hort ✓ Fördern - bilden - erleben ✓ Clevere Eigenprodukte » Jetzt bei Wehrfritz!',
  },
};
